export default __webpack_public_path__ + "static/media/Penny Bun13.4e690061.jpg";